import React, { useState, useEffect } from "react";
import "../CSS/SemuaDataPasienAdmin.css";
import { FaSearch, FaDownload, FaTrash } from "react-icons/fa";
import jsPDF from "jspdf";

function DataScreeningAdmin() {
  const [dataScreening, setDataScreening] = useState([]);
  const [loading, setLoading] = useState(true);

  // ================= LOAD DATA =================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch("https://api-tibismart.tifpsdku.com/api/screening/all");
        const data = await res.json();
        console.log("Data screening:", data);
        setDataScreening(data);
      } catch (err) {
        console.error("Gagal load data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // ================= REKOMENDASI =================
  const getRekomendasi = (hasil) => {
    if (!hasil) return "-";
    if (hasil.toUpperCase().includes("NORMAL"))
      return "Pemeriksaan rutin disarankan.";
    return "Disarankan pemeriksaan lanjutan (TCM / Tes Dahak).";
  };

  // ================= HAPUS (UI ONLY) =================
  const handleHapus = async (id) => {
    const konfirmasi = window.confirm(
      "Yakin ingin menghapus data screening ini?"
    );

    if (!konfirmasi) return;

    try {
      const response = await fetch(
        `https://api-tibismart.tifpsdku.com/api/screening/${id}`,
        {
          method: "DELETE",
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Gagal menghapus data.");
      }

      // Hapus dari tabel tanpa reload
      setDataScreening((prev) =>
        prev.filter((item) => item.id_screening !== id)
      );

      alert(result.message || "Data berhasil dihapus.");
    } catch (error) {
      console.error("Delete gagal:", error);
      alert(error.message);
    }
  };

  // ================= PDF =================
  const handleDownloadPDF = (d) => {
    const doc = new jsPDF();
    doc.text("HASIL SCREENING TBC", 105, 20, { align: "center" });

    doc.setFontSize(11);
    doc.text(`Nama Pasien      : ${d.nama_pasien || "-"}`, 20, 40);
    doc.text(`Jenis Kelamin    : ${d.jenis_kelamin || "-"}`, 20, 48);
    doc.text(`Umur             : ${d.umur || "-"}`, 20, 56);
    doc.text(`Alamat           : ${d.alamat || "-"}`, 20, 64);
    doc.text(`Tanggal Screening: ${d.tanggal || "-"}`, 20, 72);
    doc.text(`Tenaga Medis     : ${d.tenaga_kesehatan || "-"}`, 20, 80);

    doc.line(20, 86, 190, 86);
    doc.text(`Hasil Screening  : ${d.hasil || "-"}`, 20, 98);
    doc.text(`Confidence Level : ${d.confidence_level || "-"}`, 20, 106);
    doc.text(
      `Rekomendasi      : ${getRekomendasi(d.hasil)}`,
      20,
      114
    );

    doc.save(`Screening_${d.nama_pasien || "Pasien"}.pdf`);
  };

  // ================= FILTER =================
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const filteredData = dataScreening.filter((d) =>
    d.nama_pasien?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData.slice(
    indexOfFirstRow,
    indexOfLastRow
  );
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  if (loading) return <p>Loading data...</p>;


  // ================= UI =================
  return (
    <div className="data-pasien-page">
      <div className="content-pasien">
        <div className="filter-section">
          <div className="search-boxpasien">
            <FaSearch className="search-icon" />
            <input
              placeholder="Cari Nama Pasien"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="table-wrapper">
          <table className="table-pasien">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Pasien</th>
                <th>Tenaga Medis</th>
                <th>Jenis Kelamin</th>
                <th>Umur</th>
                <th>Alamat</th>
                <th>Tanggal</th>
                <th>Hasil</th>
                <th>Confidence</th>
                <th>Rekomendasi</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.map((d, i) => (
                <tr key={d.id_screening}>
                  <td>{indexOfFirstRow + i + 1}</td>
                  <td>{d.nama_pasien}</td>
                  <td>{d.tenaga_kesehatan}</td>
                  <td>{d.jenis_kelamin}</td>
                  <td>{d.umur}</td>
                  <td>{d.alamat}</td>
                  <td>{d.tanggal}</td>
                  <td>{d.hasil}</td>
                  <td>{d.confidence_level}</td>
                  <td>{getRekomendasi(d.hasil)}</td>
                  <td>
                    <button title="Download PDF"
                      onClick={() => handleDownloadPDF(d)}>
                      <FaDownload />
                    </button>
                    <button onClick={() => handleHapus(d.id_screening)}>
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Prev
          </button>

          {(() => {
            const pages = [];
            const maxVisible = 5;

            let start = Math.max(1, currentPage - 2);
            let end = Math.min(totalPages, start + maxVisible - 1);

            if (end - start < maxVisible - 1) {
              start = Math.max(1, end - maxVisible + 1);
            }

            // Tombol halaman pertama
            if (start > 1) {
              pages.push(
                <button key={1} onClick={() => setCurrentPage(1)}>
                  1
                </button>
              );

              if (start > 2) {
                pages.push(<span key="start-dots">...</span>);
              }
            }

            // Halaman di sekitar current page
            for (let i = start; i <= end; i++) {
              pages.push(
                <button
                  key={i}
                  className={currentPage === i ? "active" : ""}
                  onClick={() => setCurrentPage(i)}
                >
                  {i}
                </button>
              );
            }

            // Tombol halaman terakhir
            if (end < totalPages) {
              if (end < totalPages - 1) {
                pages.push(<span key="end-dots">...</span>);
              }

              pages.push(
                <button
                  key={totalPages}
                  onClick={() => setCurrentPage(totalPages)}
                >
                  {totalPages}
                </button>
              );
            }

            return pages;
          })()}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default DataScreeningAdmin;